export default __webpack_public_path__ + "static/media/215741.a2c09907.png";